import EventTypes from "../../../shared/EventTypes";
import AbstractAction from "../AbstractAction";

export default class ToggleCustomLabelVisibilityAction extends AbstractAction {
    constructor(provider, label) {
        super(provider);

        this.label = label;
    }

    finish() {
        this.label.visible = !this.label.visible;
        this.emit(EventTypes.UPDATE_ELEMENT_LABELS, this.label.parent.parent);
        super.finish();
    }

    undo() {
        this.label.visible = !this.label.visible;
        this.emit(EventTypes.UPDATE_ELEMENT_LABELS, this.label.parent.parent);
    }

    redo() {
        this.label.visible = !this.label.visible;
        this.emit(EventTypes.UPDATE_ELEMENT_LABELS, this.label.parent.parent);
    }
}
